const KEY = "chunkReloadAt";

/**
 * A tab opened before a deploy requests hashed chunks the new build no longer
 * serves. Reload once to pick up the new build; the 10s window stops a reload
 * loop when the chunk is still missing after the reload.
 */
export function reloadOnStaleChunk(): void {
  window.addEventListener("vite:preloadError", () => {
    const lastReload = Number(sessionStorage.getItem(KEY));

    if (Date.now() - lastReload > 10_000) {
      sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
    }
  });
}
